define('views/user/login/validatemachine',["backbone",
        "text!views/user/login/validatemachine.html",
        "views/_base/baseview",
        "models/shared/securityquestions/securityquestion",
        "models/shared/securityquestions/securityquestion_collection"
], function (Backbone, Template, BaseView, SecurityQuestion, SecurityQuestionCollection) {
    "use strict";

    return BaseView.extend({
        template: _.template(Template),
        isRender: true,
        needsAuth: false,
        tagName:"section",
        initialize: function (options) {
            options = options || {};
            this.resp = options.resp;

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        events: {
            "click #validateAnswer": "submitAnswer"
        },
        render: function () {

            this.sq = pf.session.get("SecurityQuestions").models[0];

            this.$el.html(this.template({data:this.sq}));
            return this;
        },
        loadData:function(){
        },
        submitAnswer: function (e) {

            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var securityQuestions = new SecurityQuestionCollection();            
            this.sq.set("EID", this.sq.ExtSecurityQuestionID);
            securityQuestions.add(this.sq.set("A", encrypt(this.$("#answerSet1").val())));
            var that = this;
            var url = pf.url + "/Machine/Validate?UserGUID="+pf.session.attributes.UserGUID+"&FingerPrint=" + $.fingerprint() + "&Remember=true";
            $.ajax({
                type: 'POST',
                async: false,
                data: JSON.stringify(securityQuestions),
                url: url,
                contentType: "application/json",
                success: function () {
                    pf.session.saveToken(that.resp);
                    pf.navigate("merchants/online");
                },
                error: function () {                    
                    pfdialog.error({ context: this, Body: "Failed to verify the provided answers", Title: "Failed" });
                }
            });
        },
        addTooltip: function (selector, errorMessage) {
            var item = selector;
            item.tooltipster({
                // position: 'right'
            });
            item.addClass("hasError");
            item.tooltipster('enable');
            item.tooltipster("content", errorMessage);
        },
        removeTooltip: function (selector) {
            var item = selector;
            item.tooltipster();
            item.removeClass("hasError");
            item.tooltipster("hide");
            item.tooltipster('disable');
        },
        showToolTip: function (e) {
            var item = e.target;
            if (item.tooltipster) {
                item.tooltipster('enable');
                item.tooltipster("show");
            }
        },
        close: function () {
            var that = this;
            this.$("#loginForm").off("submit", function (e) { that.login(e) });
            pf.globalEvents.off("goToInvitationAccount");
            this.cleanupEvents();
        }
    });
});

